import React, { useEffect, useRef, useState } from 'react';
import './integration.scss';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import fileDownload from 'js-file-download';
import {
  getJsonFromStorage,
  getPaginationOpts, getResponseError,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { exportMaisEguById, loadMaisEguById, loadMaisEguList } from '../actions';
import { getSystemData } from '../../System/reducer';
import { getIntegrationData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { statusFormatter, dateTimeFormatter } from '../../../utils/formatters';
import { MAIS_EGU_TYPE_STATUS_NAMES, POPUP_LIST_NAME } from '../../../configs';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import { errorNotification } from '../../Notifications/notificationDecorator';
import MaisEguForm from './MaisEguForm';
import MaisEguHistoryDialog from './MaisEguHistoryDialog';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import { INTEGRATION_MODULE } from '../../../configs/moduleNames';
import getDefaultSort from '../../../utils/getDefaultSort';
import { addGlobalPopUpWrapper } from '../../InformationScreenWrapper/actions';
import TimerLoader from '../../../components/base/Loader/TimerLoader';

export default function MaisEguPage() {
  const blockRef = useRef(null);
  const dispatch = useDispatch();
  const store = useStore();
  const { updatePeriod } = useSelector(getSystemData);
  const {
    maisEguListMeta,
    loadingMaisEguList,
    maisEguList,
    loadingCurrentMaisEgu,
    currentMaisEgu,
    loadingEditMaisEgu,
    loadingExportMaisEguById,
  } = useSelector(getIntegrationData);
  const [showHistory, setShowHistory] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const { formatMessage } = useIntl();
  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[INTEGRATION_MODULE].maisEguListMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: getValues(),
      sort,
    };
    const p1 = dispatch(loadMaisEguList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  const defaultDate = getDefaultDataRange();
  const defaultFilterValues = {
    created_at_from: defaultDate[0], created_at_to: defaultDate[1], search: '', created_at: '',
  };
  const { getValues, setValue, control } = useForm({ defaultValues: getJsonFromStorage('registry-export-filter', defaultFilterValues) });

  const handleEdit = item => event => {
    if (!item) {
      return;
    }
    dispatch(loadMaisEguById(item.id))
      .then(() => {
        setIsEdit(true);
      })
      .catch(response => errorNotification('Загрузка записи', getResponseError(response)));
  };
  const handleShowHistory = item => {
    if (!item) {
      return;
    }
    dispatch(loadMaisEguById(item.id))
      .then(() => {
        setShowHistory(true);
      })
      .catch(response => errorNotification('Загрузка записи', getResponseError(response)));
  };

  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    return classes.join(' ');
  };

  const handleExport = item => event => {
    if (!item) {
      return;
    }
    dispatch(exportMaisEguById(item.id))
      .then(data => {
        if (data) { fileDownload(data, 'Заявка в МАИС ЭГУ.pdf'); }
      })
      .catch(response => errorNotification('Экспорт заявки', 'Не удалось экспортировать заявку'));
  };

  const columns = [
    {
      dataField: 'id',
      text: 'ID',
    },
    {
      dataField: 'procedure',
      text: 'Код услуги МАИС ЭГУ',
    },
    {
      dataField: 'name',
      text: 'Наименование услуги МАИС ЭГУ',
    },
    {
      dataField: 'cron',
      text: 'Настройки расписания запросов',
    },
    {
      dataField: 'status',
      text: 'Статус',
      formatter: a => statusFormatter(a, 'mais.egu.type.status', MAIS_EGU_TYPE_STATUS_NAMES),
    },
    {
      dataField: 'created_at',
      text: 'Дата создания',
      formatter: dateTimeFormatter,
    },
  ];

  const [sort, setSort] = useState(getDefaultSort(columns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);

  const renderContextMenu = item => (
    <div className="more-wrapper">
      <Button variant="link" className="w-100 more-button" onClick={handleEdit(item)}>
        Редактировать
      </Button>
      <Button variant="link" className="w-100 more-button" onClick={() => handleShowHistory(item)}>
        История запросов
      </Button>
      <Button variant="link" className="w-100 more-button" onClick={handleExport(item)}>
        Экспорт заявки
      </Button>
    </div>
  );

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={renderContextMenu(item)}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  return (
    <div className="page application-page">
      <TimerLoader global loading={loadingMaisEguList || loadingCurrentMaisEgu || loadingEditMaisEgu || loadingExportMaisEguById} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.integration.mais.egu' })}</div>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <CustomizedGrid
                data={maisEguList}
                columns={columns}
                name="mais-egu-list"
                settingsFormatter={moreFormatter}
                renderContextMenu={renderContextMenu}
                onDoubleClickByRow={item => handleShowHistory(item)}
                changeSort={changeSort}
                sort={sort}
                rowClassFormatter={rowClassFormatter}
              />
            </div>
          </div>
          <Pagination meta={maisEguListMeta} list={maisEguList} handleChangeMeta={loadData} />
        </div>
      </div>
      {isEdit && currentMaisEgu ? <MaisEguForm current={currentMaisEgu} loadData={loadData} close={() => setIsEdit(false)} /> : null}
      {showHistory && currentMaisEgu ? <MaisEguHistoryDialog current={currentMaisEgu} close={() => setShowHistory(false)} /> : null}
    </div>
  );
}
